
export default {
  props: {
    e5namespace: {
      type: String,
      default: 'e5'
    }
  }
}
